import React, { Component } from 'react'
import { connect } from 'react-redux'

import appConfig from '../config/app'

import { getPostcard } from '../actions/PostcardActions'
import StepButton from '../components/step-button/StepButton'
import Share from '../components/share/Share'

import './_app.css'

class Postcard extends Component {
  static defaultProps = {
    postcard: {}
  }

  constructor(props) {
    super(props)
    this.state = {
      isDrop: false,
      isEti: false,
      origin: ''
    }
  }

  handleStorageClean = () => {
    localStorage.setItem('postcard', JSON.stringify({
      "gender": 1,
      "type": 1,
      "text": 1,
      "startPhrase": "",
      "name": "",
      "background": 1,
      "thumb_path": "",
      "short_link": "",
      "origin_image": ""      
    }))
  }

  componentWillMount() {
    this.props.dispatch(getPostcard(this.props.params.link)).then(() => {
      var metaOg = document.getElementById('ogImg')
      var metaOgUrl = document.getElementById('ogImgUrl')
      metaOg.content = `${appConfig.basePath}${this.props.postcard.origin_image}`
      metaOgUrl.content = `${appConfig.basePath}${this.props.postcard.origin_image}`      
    })
  }

  handleDropCard = (drop, origin) => {
    this.setState({
      isDrop: drop,
      isEti: drop,
      origin: origin
    })
  }

  render() {
    const { postcard } = this.props
    const { isDrop, isEti, origin } = this.state

    return (
      <div className="app-root">
        <div className="postcard-logo"></div>
        <div className="rope"></div>

        <div className={`wrapper ${(isDrop) ? 'none' : ''}`}>
          <div className="pin left"></div>
          <div className="pin right"></div>           
          <div className="paper-wrap noback">     
            <div className="sensor left" onClick={
              () => {
                if(!isDrop) {
                  this.handleDropCard(true, 'right')
                }
              }
            }></div>
            <div className="sensor right" onClick={
              () => {
                if(!isDrop) {
                  this.handleDropCard(true, 'left')
                }
              }
            }></div>
            <div className="white-box card-wrap">
              <div className="card-overlay lone">
                <Share card={postcard}/>
                <span style={{display: 'inline-block', paddingTop: '10px'}}>поделись или скопируй:</span>
                <span className="card-link" to={`/postcard/${postcard.short_link}`}>
                {`${appConfig.basePath}postcard/${postcard.short_link}`}
                </span>
              </div>            
              <img ref="dropcard" 
              className={`card animated ${isDrop ? 'hinge-' : ''}${origin}`} 
              role="presentation" 
              src={appConfig.basePath+postcard.origin_image} />
            </div>
            
            <StepButton title="Создать свою открытку" onNavigate={this.handleStorageClean} navigateTo="welcome"/>
          </div>

          <div className="copyrights">
            <div className="logo"></div>
            <span><a href="http://www.atwinta.ru" target="_blank">Создание сайта</a> Атвинта</span> 
          </div>
          <div className="big-present-box"></div>
          <div className="present-boxes"></div>
        </div>
        <div className={`eti ${(isEti) ? 'show' : ''}`}>
          <div className="refresh-page" onClick={ () => { location.reload() }}>Обновить</div>
        </div>  
      </div>
    );
  }
}

export default connect((state) => ({
  postcard: state.postcard.data
}))(Postcard)


// WEBPACK FOOTER //
// ./src/containers/Postcard.js